module.exports = __webpack_public_path__ + "637e8d38.svg";